import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 5.296V5a4.5 4.5 0 00-9 0v.296A3.981 3.981 0 011.508 8.75C.867 9.118.5 9.544.5 10c0 1.381 3.358 2.5 7.5 2.5 4.142 0 7.5-1.119 7.5-2.5 0-.456-.367-.882-1.008-1.25A3.98 3.98 0 0112.5 5.296zM10.292 14a2.5 2.5 0 01-4.584.001",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }